import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getNotificationResponse,
  getUnreadCountResponse,
  markAsReadData,
} from './Notification.model';

import { notification } from '../../api/Endpoints';

import { QUERY_KEYS } from '../../api/config';

export const useGetNotificationQuery = (options = {}) => {
  return useQuery<getNotificationResponse, Error>({
    ...options,
    queryKey: [QUERY_KEYS.ALL_NOTIFICATIONS],
    queryFn: async () => {
      const response = await notification.getNotification();
      return response.data;
    },
  });
};

export const useMarkAsReadMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<[], Error, markAsReadData>({
    mutationFn: (data: markAsReadData) => {
      return notification.markAsRead(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          QUERY_KEYS.ALL_NOTIFICATIONS,
          QUERY_KEYS.ALL_NOTIFICATIONS_COUNT,
        ],
      });
    },
  });
};

export const useGetUnReadMessageCountQuery = () => {
  return useQuery<getUnreadCountResponse, Error>({
    queryKey: [QUERY_KEYS.ALL_NOTIFICATIONS_COUNT],
    queryFn: async () => {
      const response = await notification.getUnReadMessageCount();
      return response.data;
    },
  });
};

// export const useDeleteNotificationMutation = (onSuccess) => {
//   return useMutation<
//     AxiosResponse<VIResponse<getDeleteNotificationResponse>>,
//     Error,
//     deleteNotificationData
//   >({
//     onSuccess,
//     mutationFn: (data: deleteNotificationData) => {
//       return notification.deleteNotification(data);
//     },
//   });
// };
